// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_EG4JPJ4qUEcMnqmztAKXDh41HfwL" as const;
export const builtAt = "2026-11-05T03:33:23.286Z" as const;
export const vercelEnv: string | null = "preview";
export const gitCommitSha: string | null = "84aa69099d362525b729c98edcbff0406d4f5b4f";
export const deploymentId: string | null = "dpl_EG4JPJ4qUEcMnqmztAKXDh41HfwL";
